import { capitalizeExportValue } from 'lib/helpers/capitalizeExportValue';

import { generateHeaderName } from 'components/practice/BeyondBilling/Reports/components/ReportView/lib/generateColumnDefs';

import exportToCsv from './exportToCsv';
import exportToExcel from './exportToExcel';
import { flattenNestedData } from './flattenNestedData';

const EMPTY_CELL = '-';

const namespaceParentColumns = (parentColumns, childColumns) => {
  const childHeaderNames = new Set(childColumns.map((col) => col.headerName));

  return parentColumns.map((col) => ({
    ...col,
    field: `parent_${col.field}`,
    headerName: childHeaderNames.has(col.headerName) ? `Parent ${col.headerName}` : col.headerName
  }));
};

const buildUniqueHeaders = (columns) => {
  const usedLabels = new Set();

  return columns.map((col) => {
    const baseLabel = col.headerName || generateHeaderName(String(col.field));

    let label = baseLabel;
    let suffix = 2;
    while (usedLabels.has(label)) {
      label = `${baseLabel} (${suffix})`;
      suffix += 1;
    }
    usedLabels.add(label);

    return { field: col.field, label };
  });
};

export const exportSpreadsheet = ({
  values,
  data,
  finalColumns,
  finalParentColumns,
  isDetailedMode,
  hasExpandableRows
}) => {
  const flattenedData = flattenNestedData(data, finalColumns, {
    mode: hasExpandableRows ? values.export_data : 'summary',
    parentColumns: isDetailedMode ? finalParentColumns : []
  });

  const headerColumns = isDetailedMode
    ? [...namespaceParentColumns(finalParentColumns, finalColumns), ...finalColumns]
    : finalColumns;

  const headers = buildUniqueHeaders(headerColumns);

  const formattedDataColumns = flattenedData.map((row) =>
    Object.fromEntries(
      headers.map(({ field, label }) => {
        const value = row[field];
        return [
          label,
          value === undefined || value === null || value === ''
            ? EMPTY_CELL
            : capitalizeExportValue(value)
        ];
      })
    )
  );

  if (values.export_type.includes('csv')) {
    exportToCsv(formattedDataColumns, values.title);
  }

  if (values.export_type.includes('excel')) {
    exportToExcel(formattedDataColumns, values.title);
  }
};
